 /** キーワード入力上限数 */
 export const KEYWORD_COUNT = 50;
  /** 表示件数上限 */
 export const DISPLAY_COUNT = 8;
  /** セッション上限 */
 export const SESSIONVAL = 11;
  /** 戻るボタン押下後のスクロール位置再現までの時間 */
  //iosの黒画面解消が100でsetしているため、スクロール位置再現はその後の挙動を起こす必要があり110で定義
 export const SCROLLINTERVAL = 110;